import src from "IMAGE";
export default { src, width: 510, height: 80, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJElEQVR42mNgYWHh5uTk1Ofj44sAYl9+fv5wII7j4uLSBckBACuqAszFhQBXAAAAAElFTkSuQmCC"};
